import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import InvoiceForm from '../../components/Factures/InvoiceForm';

const NewInvoicePage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { initialValues, returnTo } = location.state || {};

  const closeForm = () => navigate(returnTo || (
    location.pathname.startsWith('/sales-module') ? '/sales-module/invoices' : '/ventes/factures'
  ));

  return (
    <InvoiceForm
      initialValues={initialValues || {
        lignes: [],
        dateFacture: new Date().toLocaleDateString('en-CA', { timeZone: 'Africa/Casablanca' }),
        dateEcheance: new Date().toLocaleDateString('en-CA', { timeZone: 'Africa/Casablanca' })
      }}
      onClose={closeForm}
    />
  );
};

export default NewInvoicePage;
